import { useState, useCallback } from 'react';
import EventStream from '../telemetry/EventStream';
import { SprintRunSelector, PreviousAttemptsAccordion } from './SprintRunSelector';
import type { SprintRun } from '../../api/sprint';
import { useSprintRuns } from '../../hooks/useSprintData';

interface Props {
  sprint: any;
}

export function MonitorEventsTab({ sprint }: Props) {
  const [runBatchId, setRunBatchId] = useState<string | null>(null);
  const [selectedRun, setSelectedRun] = useState<SprintRun | null>(null);
  const { data: runsData } = useSprintRuns(sprint?.id);

  const handleRunChange = useCallback((batchId: string | null, run: SprintRun | null) => {
    setRunBatchId(batchId);
    setSelectedRun(run);
  }, []);

  // Use the run-specific batchId if available, otherwise fall back to sprint.batchId
  const activeBatchId = runBatchId ?? sprint?.batchId;
  const runs = runsData?.runs ?? [];

  return (
    <div className="space-y-5">
      {/* Run selector — shows pill bar + detail card when multiple runs exist */}
      <SprintRunSelector
        sprintId={sprint?.id}
        onRunChange={handleRunChange}
      />

      {/* Event stream scoped to the selected run's batchId */}
      <EventStream
        batchId={activeBatchId}
        sprintId={sprint?.id}
      />

      {/* Previous attempts accordion — collapsed by default, below telemetry */}
      {selectedRun && runs.length > 1 && (
        <PreviousAttemptsAccordion
          runs={runs}
          currentRunId={selectedRun.id}
          onSelectRun={(run) => handleRunChange(run.batchId, run)}
        />
      )}
    </div>
  );
}
